import Markdown from "react-markdown";
import type { ChatMessage as ChatMessageType } from "../../lib/api";

interface ChatMessageProps {
  message: ChatMessageType;
}

export function ChatMessage({ message }: ChatMessageProps) {
  const isUser = message.role === "user";
  const isSystem = message.role === "system";
  const time = new Date(message.timestamp).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  });

  if (isSystem) {
    const isAccepted = message.content.toLowerCase().includes("updated");
    return (
      <div className="flex justify-center">
        <div
          className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs ${
            isAccepted
              ? "bg-green-50 text-green-700 border border-green-200"
              : "bg-gray-50 text-gray-500 border border-gray-200"
          }`}
        >
          <span>{message.content}</span>
          <span className="opacity-60">{time}</span>
        </div>
      </div>
    );
  }

  if (isUser) {
    return (
      <div className="flex justify-end">
        <div className="max-w-[85%] rounded-lg px-4 py-2 bg-brand-600 text-white">
          <p className="text-sm whitespace-pre-wrap">{message.content}</p>
          <p className="text-xs mt-1 text-brand-200">{time}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full text-gray-900">
      <div className="text-sm prose prose-sm prose-gray max-w-none prose-p:my-1 prose-ul:my-1 prose-ol:my-1 prose-li:my-0 prose-headings:my-2 prose-headings:text-gray-900 prose-strong:text-gray-900 prose-code:text-brand-700 prose-code:bg-gray-200 prose-code:px-1 prose-code:py-0.5 prose-code:rounded prose-code:before:content-none prose-code:after:content-none">
        <Markdown>{message.content}</Markdown>
      </div>
      <p className="text-xs mt-1 text-gray-400">{time}</p>
    </div>
  );
}
